import { API_URL } from '../config/api';

/**
 * 🏗️ ARQUITETURA MODULAR - Product Edit Service (Frontend)
 * 
 * Service responsável por comunicação com a API de edição de produtos
 * Segue padrão obrigatório: Usar API_URL do config
 */
class ProductEditService {
  constructor() {
    this.baseURL = `${API_URL}/api/products`;
  }

  /**
   * 🔐 Obter token de autenticação
   */
  getAuthToken() {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Token de autenticação não encontrado');
    }
    return token;
  }

  /**
   * 🌐 Configuração padrão para requests
   */
  getRequestConfig() {
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAuthToken()}`
      }
    };
  }

  /**
   * 📝 Atualizar informações básicas do produto
   */
  async updateProductInfo(productUuid, productData) {
    try {
      const response = await fetch(`${this.baseURL}/${productUuid}/info`, {
        method: 'PUT',
        ...this.getRequestConfig(),
        body: JSON.stringify(productData)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Erro ao atualizar informações do produto');
      }

      return result;

    } catch (error) {
      console.error('❌ Erro ao atualizar informações do produto:', error);
      throw error;
    }
  }

  /**
   * 📦 Atualizar configurações de frete e dimensões
   */
  async updateShippingInfo(productUuid, shippingData) {
    try {
      const response = await fetch(`${this.baseURL}/${productUuid}/shipping`, {
        method: 'PUT',
        ...this.getRequestConfig(),
        body: JSON.stringify(shippingData)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Erro ao atualizar configurações de frete');
      }

      return result;

    } catch (error) {
      console.error('❌ Erro ao atualizar configurações de frete:', error);
      throw error;
    }
  }

  /**
   * 🔍 Buscar produto por UUID
   */
  async getProductByUuid(productUuid) {
    try {
      const response = await fetch(`${this.baseURL}/uuid/${productUuid}`, {
        method: 'GET',
        ...this.getRequestConfig()
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Erro ao buscar produto');
      }

      return result;

    } catch (error) {
      console.error('❌ Erro ao buscar produto por UUID:', error);
      throw error;
    }
  }

  /**
   * 🆔 Gerar UUIDs para produtos existentes (admin only)
   */
  async generateUuidsForExistingProducts() {
    try {
      const response = await fetch(`${this.baseURL}/generate-uuids`, {
        method: 'POST',
        ...this.getRequestConfig()
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Erro ao gerar UUIDs');
      }

      return result;

    } catch (error) {
      console.error('❌ Erro ao gerar UUIDs:', error);
      throw error;
    }
  }
}

// Instância singleton
const productEditService = new ProductEditService();

export default productEditService;








